module.exports = __webpack_public_path__ + "img/RBT.15a70a39.svg";